import { LogOut, User } from "lucide-react";
import { NavLink, useLocation, useNavigate } from "react-router";

import { WorkspaceLabel } from "@/components/layout/workspace-label";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useLogout } from "@/hooks/use-auth";
import { cn } from "@/lib/utils";

import {
  activityLogNav,
  dashboardNav,
  financeNav,
  globalSettingsNav,
  inventoryNav,
  salesNav,
  workspaceDataNav,
} from "../nav-config";
import { SidebarFlatItems, SidebarSubGroup } from "./sidebar-nav-items";

const mainNav = [dashboardNav, activityLogNav];

// "/settings/workspace" is a prefix of its sibling pages, so it only matches exactly.
const workspaceDataActive = (pathname: string, to: string) =>
  pathname === to || (to !== "/settings/workspace" && pathname.startsWith(to));

export function DesktopSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const accountActive = location.pathname === "/settings/account";

  async function handleLogout() {
    await logout();
    navigate("/login");
  }

  return (
    <Sidebar>
      <SidebarHeader className="border-b px-4 py-3">
        <WorkspaceLabel />
      </SidebarHeader>

      <SidebarContent>
        <SidebarFlatItems items={mainNav} />
        <SidebarSubGroup label="Penjualan" items={salesNav} />
        <SidebarSubGroup label="Keuangan" items={financeNav} />
        <SidebarSubGroup label="Inventaris" items={inventoryNav} />
        {/* Master data + this store's own settings — both vary per workspace */}
        <SidebarSubGroup
          label="Master Data & Pengaturan Toko"
          items={workspaceDataNav}
          isActive={workspaceDataActive}
        />
        {/* Pengaturan Global (Lintas Workspace) */}
        <SidebarFlatItems label="Pengaturan Global" items={globalSettingsNav} />
      </SidebarContent>

      <SidebarFooter className="border-t px-2 py-2 space-y-1">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild isActive={accountActive}>
              <NavLink
                to="/settings/account"
                className={cn(
                  "flex items-center gap-2",
                  accountActive && "font-medium text-primary",
                )}
              >
                <User className="h-4 w-4" />
                <span>Akun Saya</span>
              </NavLink>
            </SidebarMenuButton>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton
              onClick={handleLogout}
              className="w-full cursor-pointer text-muted-foreground hover:text-destructive"
            >
              <LogOut className="h-4 w-4" />
              Keluar
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  );
}
